module.exports = __webpack_public_path__ + "media/images/icons/arrow_circle_down-8b7fa796a0c67401c1ea0302bf882a5d.svg";